import "./Header.css"

export default function Header() {
    return(
        <div className="header">
            <p>Site no longer maintained. Please visit <a href="https://graceis.online/">graceis.online</a> for my current portfolio.</p>
        </div>
    )
}